import React from 'react';

import { events, openApp, permissions, withRouter } from 'src/helpers';
import { View } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import { tabs } from 'src/components/mobile/utils';
import messagesModel from 'src/components/messages/model';
import { popupModel } from 'src/components/complex';
import AuthPopup from 'src/components/authPopup';

import { CHANGE_MOBILE_PAGES_EVENT_ID, MOBILE_PAGES } from './utils';
import model from './model';
import doctorsModel from './doctorsModel';
import mobilePages from './MobileComponents';
import WebComponents from './WebComponents';
import doctorModel from './doctorModel';
import managersModel from './managersModel';
import locationsModel from './locationsModel';

class ClinicProfile extends BaseComponent {
  state = {
    loading: true,
    mobilePage: MOBILE_PAGES.INDEX,
    pageParams: null,
    history: [{ mobilePage: MOBILE_PAGES.INDEX }]
  };
  componentDidMount() {
    let activeTab = this.props.router.params.tab || 'doctors';

    if (!tabs.find((t) => t.id === activeTab)) {
      activeTab = 'doctors';
      setTimeout(() => {
        this.navigate(permissions.PAGES.PROFILE_PAGE.match(this.props.router.params.username), {
          replace: true
        });
      }, 0);
    }

    model.setStateSilent({ activeTab });
    model.setStateSilent({ clinic: this.props.clinic });
    doctorsModel.setStateSilent({ clinic: this.props.clinic });
    managersModel.setStateSilent({ clinic: this.props.clinic });
    locationsModel.setStateSilent({ clinic: this.props.clinic });
    locationsModel.refresh();
    managersModel.refresh();
    model.foxsocket().subscribe('g-general');
    model.foxsocket().connect();

    model.subscribe(this.subscription);
    model.on(CHANGE_MOBILE_PAGES_EVENT_ID, this.changePage);

    if (this.props.router.location.state?.doctor) {
      const doctor = this.props.router.location.state?.doctor;
      doctorsModel.startProcess = { doctor };
      this.onDoctorItem(doctor);
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel(CHANGE_MOBILE_PAGES_EVENT_ID, this.changePage);
  }

  changePage = (data) => {
    let mobilePage = data,
      pageParams = null;
    if (typeof data !== 'string') {
      mobilePage = data.page;
      pageParams = data.params;
    }
    const history = this.state.history;
    if (history[history.length - 1].mobilePage !== mobilePage)
      history.push({ mobilePage, pageParams });
    else history[history.length - 1].pageParams = { mobilePage, pageParams };
    this.setState({ mobilePage, pageParams, history });
  };

  onSendMsg = (contact) => {
    events.emit(CHANGE_MOBILE_PAGES_EVENT_ID, MOBILE_PAGES.MESSAGE_PAGE);

    let screenDetail = this.props.screenDetail;
    if (!screenDetail.isSmallScreen) return;
    messagesModel.emit('openContact', { contact: { ...contact, partnerId: contact.id } });
  };

  onBook = (doctor) => {
    let slot = doctorModel.state.slots[0];
    if (model.isLogged) {
      if (!openApp({ action: 'book', contactId: doctor.id }))
        this.navigate(permissions.PAGES.APPOINTMENTS_BOOK_PAGE.match(doctor.username), {
          state: { slot }
        });
    } else {
      popupModel.setActivePopup('auth_popup', {
        active: true,
        component: AuthPopup,
        props: {
          role: 'patient',
          afterAuth: () => {
            if (!openApp({ action: 'book', contactId: doctor.id })) {
              setTimeout(() => {
                this.navigate(permissions.PAGES.APPOINTMENTS_BOOK_PAGE.match(doctor.username), {
                  state: { slot }
                });
              }, 200);
            }
            popupModel.setActivePopup('auth_popup', { active: false });
          }
        }
      });
    }
  };

  onDoctorItem = (doctor) => {
    let screenDetail = this.props.screenDetail;
    if (doctorModel.state.doctor?.id === doctor.id && !screenDetail.isSmallScreen) return;

    doctorModel.setStateSilent({ doctor });
    doctorModel.loadDetail(doctor.id);
    events.emit(CHANGE_MOBILE_PAGES_EVENT_ID, MOBILE_PAGES.DOCTOR_PAGE);
  };

  onManagerItem = (manager) => {
    let screenDetail = this.props.screenDetail;
    if (screenDetail.isSmallScreen) return this.onSendMsg(manager);
    if (!screenDetail.isSmallScreen && this.state.mobilePage !== MOBILE_PAGES.MESSAGE_PAGE) return;
    if (!screenDetail.isSmallScreen && manager.id === locationsModel.state.manager?.id) return;
    locationsModel.setState({ manager });
  };

  onLocation = (location) => {
    locationsModel.setState({ location });
    events.emit(CHANGE_MOBILE_PAGES_EVENT_ID, MOBILE_PAGES.LOCATION_PAGE);
  };

  onBack = () => {
    let history = this.state.history;
    if (history.length > 1) {
      history.pop();
      let { mobilePage, pageParams } = history[history.length - 1];
      this.setState({ mobilePage, pageParams });
    } else {
      this.navigate(permissions.PAGES.PROFILE_PAGE.match(this.props.router.params.username), {
        replace: true
      });
    }
  };

  onActiveTab = (activeTab) => {
    this.navigate(
      permissions.PAGES.PROFILE_PAGE.match(this.props.router.params.username, activeTab),
      {
        replace: true
      }
    );
    events.emit(CHANGE_MOBILE_PAGES_EVENT_ID, MOBILE_PAGES.INDEX);
    model.setState({ activeTab });
  };

  onChatSupport = (location, setLoading) => {
    locationsModel.setState({ location });
    let screenDetail = this.props.screenDetail;
    if (screenDetail.isSmallScreen) {
      managersModel.selectHospitalId(location?.id);
      events.emit(CHANGE_MOBILE_PAGES_EVENT_ID, MOBILE_PAGES.MANAGERS_PAGE);
    } else {
      setLoading && setLoading(true);
      const refresh = (items) => {
        locationsModel.setStateSilent({ manager: items[0] });
        this.onSendMsg(items[0]);

        managersModel.cancel('ClinicProfileManagersModel_refresh', refresh);
        setLoading && setLoading(false);
      };
      managersModel.on('ClinicProfileManagersModel_refresh', refresh);
      managersModel.selectHospitalId(location?.id);
    }
  };

  render() {
    let screenDetail = this.props.screenDetail;
    let clinic = this.props.clinic;
    let activeTab = model.state.activeTab;
    let props = {};

    if (screenDetail.isSmallScreen) {
      return Object.keys(mobilePages).map((k) => {
        let Compo = mobilePages[k];
        let active = this.state.mobilePage === k;
        return (
          <View key={k} style={{ flex: 1, display: active ? 'flex' : 'none' }}>
            <Compo
              clinic={clinic}
              activeTab={activeTab}
              onActiveTab={this.onActiveTab}
              onSendMsg={this.onSendMsg}
              onBook={this.onBook}
              onDoctorItem={this.onDoctorItem}
              onManagerItem={this.onManagerItem}
              onLocation={this.onLocation}
              onChatSupport={this.onChatSupport}
              onBack={this.onBack}
              currency={model.getCurrency()}
              {...this.state.pageParams}
              {...props}
            />
          </View>
        );
      });
    }

    return (
      <WebComponents
        clinic={clinic}
        activeTab={activeTab}
        onActiveTab={this.onActiveTab}
        onSendMsg={this.onSendMsg}
        onBook={this.onBook}
        onDoctorItem={this.onDoctorItem}
        onManagerItem={this.onManagerItem}
        onLocation={this.onLocation}
        onChatSupport={this.onChatSupport}
        currency={model.getCurrency()}
        onBack={this.onBack}
        isConv={this.state.mobilePage === MOBILE_PAGES.MESSAGE_PAGE}
        {...props}
      />
    );
  }
}

export default withRouter(ClinicProfile);
